<template>
  <div class="d-flex flex-wrap justify-space-between">
    <v-sheet class="d-flex flex-wrap mr-5">
      <span
        class="text-h5 font-weight-bold mr-3 my-2"
        :style="{'color':appStyle.title_text_color}"
      >
        {{ props.title }}
      </span>

      <v-select
        v-model="selectedConfiguration"
        :items="configurations"
        item-title="name"
        return-object
        single-line
        density="compact"
        @update:modelValue="configurationSelected"
      />
    </v-sheet>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStoreManager } from '@/stores/storeManager';
import { useApplicationStore } from '@/stores/applicationStore';
import { SETTINGS } from '@/constants';

const props = defineProps({
  title: {
    type: String,
    required: true
  }
});

const storeManager = useStoreManager();
const emit = defineEmits(['configurationSelected']);

const applicationStore = useApplicationStore();
const appStyle = computed(() => applicationStore.appStyle);

const selectedConfiguration = ref({});

const configurations = computed(() => {
  const rawConfigurations = storeManager.getFromStoreByCategory('configuration', 'configurations');
  const configs = Object.keys(rawConfigurations).map((key) => ({
    ...rawConfigurations[key],
    id: key
  }));
  return configs.filter(cfg => cfg.settings?.planning_type === SETTINGS.PLANNING_TYPE.FREE);
});

init();

function init() {
  selectedConfiguration.value = configurations.value[0];
  configurationSelected();
}

function configurationSelected() {
  emit('configurationSelected', selectedConfiguration.value);
}
</script>
